import { useAppDispatch, useAppSelector } from 'store/hooks';
import { updateDashboardSettings } from 'store/account/account.thunk';
import { timeoutIdSelector } from 'store/app/app.selector';
import { SET_SETTINGS_TIMEOUT_ID } from 'store/app/app.actions';

const useUpdateDashboardSettings = () => {
  const dispatch = useAppDispatch();
  const existingTimeoutId = useAppSelector(timeoutIdSelector);
  const updateTimeMilliseconds = import.meta.env.VITE_SETTINGS_UPDATE_TIME_SECONDS * 1000;
  return () => {
    if (existingTimeoutId) {
      clearTimeout(existingTimeoutId);
      dispatch(SET_SETTINGS_TIMEOUT_ID(null));
    }
    const newTimeoutId = window.setTimeout(() => {
      dispatch(updateDashboardSettings(null));
      dispatch(SET_SETTINGS_TIMEOUT_ID(null));
    }, updateTimeMilliseconds);
    dispatch(SET_SETTINGS_TIMEOUT_ID(newTimeoutId));
  };
};

export default useUpdateDashboardSettings;
